import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AIWidget from "./AIWidget";
import WhatsAppButton from "./WhatsAppButton";
import { Outlet } from "react-router-dom";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC]">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <AIWidget />
      <WhatsAppButton variant="floating" testId="whatsapp-float-public" />
    </div>
  );
}
